import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/api-reference.md';
import Alerts from '/src/pages/documentation/resources/alerts.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "configuration-api-reference"
    }}>{`Configuration API reference`}</h1>
    <Alerts query="platform=outdated-version&componentClass=InlineNestedAlert" mdxType="Alerts" />
    <h2 {...{
      "id": "configurewithappid"
    }}>{`configureWithAppID`}</h2>
    <p>{`This API causes the SDK to download the configuration for the provided app ID and apply the configuration to the current session.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="4" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=configure-with-app-id" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=configure-with-app-id" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&api=configure-with-app-id" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=configure-with-app-id" mdxType="Tabs" />
    <h2 {...{
      "id": "configurewithfileinassets"
    }}>{`configureWithFileInAssets`}</h2>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`This API is only available in Android and was added in Android was added in Android Core version 1.7.0.`}</p>
    <p>{`You can bundle a JSON configuration file in the app's Assets folder to replace or complement the configuration that was downloaded by using the `}<a parentName="p" {...{
        "href": "./index.md#configure-with-app-id-per-environment"
      }}>{`Configure with App ID per environment`}</a>{` approach.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="1" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=configure-with-file-in-assets" mdxType="Tabs" />
    <h2 {...{
      "id": "configurewithfileinpath"
    }}>{`configureWithFileInPath`}</h2>
    <p>{`You can include a bundled JSON configuration file in your app package to replace or complement the configuration that was downloaded by using the `}<a parentName="p" {...{
        "href": "./index.md#configure-with-app-id-per-environment"
      }}>{`Configure with App ID per environment`}</a>{` approach.`}</p>
    <p>{`To pass in a bundled path and file name:`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=configure-with-file-in-path" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=configure-with-file-in-path" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=configure-with-file-in-path" mdxType="Tabs" />
    <h2 {...{
      "id": "extensionversion"
    }}>{`extensionVersion`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`extensionVersion()`}</inlineCode>{` API returns the version of the Configuration extension.`}</p>
    <p>{`To get the version of the Configuration extension, use the following code sample:`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=extension-version" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=extension-version" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=extension-version" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&api=extension-version" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&api=extension-version" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&api=extension-version" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=extension-version" mdxType="Tabs" />
    <h2 {...{
      "id": "updateconfiguration"
    }}>{`updateConfiguration`}</h2>
    <p>{`You can also update the configuration programmatically by passing configuration keys and values to override the existing configuration.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Keys that are not found on the current configuration are added when this method is followed. Null values are allowed and replace existing configuration values.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`Do not use this API to update the `}<inlineCode parentName="p">{`build.environment`}</inlineCode>{` key or any key with an environment prefix, because it can lead to unexpected behaviors. For more information, read `}<a parentName="p" {...{
        "href": "./index.md#environment-aware-configuration-properties"
      }}>{`Environment-aware configuration properties`}</a>{`.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=update-configuration" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=update-configuration" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=update-configuration" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&api=update-configuration" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&api=update-configuration" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&api=update-configuration" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=update-configuration" mdxType="Tabs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      